export default "__VITE_ASSET__a30bfee1__"